<template>
<w-settings-content-template>
  <div slot="content">
    <el-row class="title-bar" type="flex" justify="space-between">
      <div class="vertical-center-box">
        <div class="title-h3">EOL/EOS 관리목록</div>
        <div class="setting-addel mr-l15">
          <el-button size="mini" @click="onAddDeviceLifeCycle"><i class="fas fa-plus"></i></el-button>
          <el-button size="mini" @click="onDelDeviceLifeCycle" :disabled="selectedRowArray.length === 0"><i class="fas fa-minus"></i></el-button>
        </div>
      </div>
      <div class="vertical-center-box">
        <el-button class="mr-r4" size="mini" @click="onClickExcelImport">
          <img src="@/assets/img/icons/excel.png" style="position:relative;left:-2px;bottom:2px;">
          <span style="left:2px;bottom:5px;">  엑셀입력</span>
        </el-button>
        <el-button class="mr-r4" size="mini" @click="onClickExcelExport">
          <img src="@/assets/img/icons/excel.png" style="position:relative;left:-2px;bottom:2px;">
          <span style="left:2px;bottom:5px;">  엑셀출력</span>
        </el-button>
        <w-header-search-button size="mini" @click="setSearchToolVisible"></w-header-search-button>
      </div>
    </el-row>
    <el-table-wrapper :column-default="columnDefault" @condition-change="onChangeTable" :total="total" remote ref="deviceModelTable" row-class-name="c-dblclick"
      @row-dblclick="onDblClickRow" @selection-change="changeHandleSelection" :data="tableData" :columns="tableColumn" :pagination="true" :show-search-tool="showSearchTool" style="width:100%;" :show-custom-header="true">
      <!-- TODO: 사용 장비 목록 조회 팝업 개발 필요 -->
      <!-- <template slot-scope="scope" slot="use-count">
          <span class="link c-pointer">{{scope.row.useCount}}</span>
        </template> -->
      <template slot-scope="scope" slot="eol-status">
          <span v-if="scope.row.eolStatus === 'O'" class="state-normal">판매 중</span>
          <span v-else-if="isNil(scope.row.eolStatus)">-</span>
          <span v-else class="state-abnormal">단종</span>
        </template>
      <template slot-scope="scope" slot="eos-status">
          <span v-if="scope.row.eosStatus === 'O'" class="state-normal">서비스 중</span>
          <span v-else-if="isNil(scope.row.eosStatus)">-</span>
          <span v-else class="state-abnormal">서비스 종료</span>
        </template>
    </el-table-wrapper>
    <w-device-life-cycle-sliding-popup ref="deviceLifeCycleSlidingPopup" @load-data="loadData"></w-device-life-cycle-sliding-popup>
    <w-device-model-excel-import-sliding-popup ref="deviceModelExcelImportSliding" @load-data="loadData"></w-device-model-excel-import-sliding-popup>
  </div>
</w-settings-content-template>
</template>

<script>
import msgUtil from '@/utils/message';
import { columnDefault } from '@/constants/table';
import WSettingsContentTemplate from '@/components/template/SettingsContentTemplate';
import { EMPTY_TEXT, getValueAfterCheckEmpty } from '@/utils/string';
import { getDateToString } from '@/utils/date';
import { isNil } from 'lodash';
import NetdeviceLifeCycleSettingsAPI from '@/api/settings/netdevice/netdevice-life-cycle-settings';
import WDeviceLifeCycleSlidingPopup from './popup/DeviceLifeCycleSlidingPopup';
import WDeviceModelExcelImportSlidingPopup from './popup/DeviceModelExcelImportSlidingPopup';

export default {
  name: 'WDeviceLifeCycleManagement',
  components: {
    WSettingsContentTemplate,
    WDeviceLifeCycleSlidingPopup,
    WDeviceModelExcelImportSlidingPopup,
  },
  data() {
    return {
      columnDefault,
      showSearchTool: false,
      selectedRowArray: [],
      tableData: [],
      tableColumn: [
        {
          align: 'center',
          type: 'selection',
        },
        {
          prop: 'objCompanyName',
          label: '벤더명',
          sortable: true,
          searchable: true,
          remoteProp: 'oc.obj_company_name',
        },
        {
          prop: 'objProductId',
          label: '모델명',
          searchable: true,
          sortable: true,
          remoteProp: 'opi.obj_product_id',
        },
        {
          prop: 'eolStatus',
          label: '판매여부',
          sortable: true,
          scopedSlot: 'eol-status',
          width: 88,
        },
        {
          prop: 'eolDate',
          label: '단종일',
          searchable: true,
          sortable: true,
          searchType: 'date',
          formatter: this.getDateFormatter,
          width: 250,
          remoteProp: 'opi.eol_date',
        },
        {
          prop: 'eosStatus',
          label: '서비스여부',
          sortable: true,
          scopedSlot: 'eos-status',
          width: 95,
        },
        {
          prop: 'eosDate',
          label: '서비스 종료일',
          searchable: true,
          sortable: true,
          formatter: this.getDateFormatter,
          searchType: 'date',
          remoteProp: 'opi.eos_date',
          width: 250,
        },
        {
          prop: 'changePeriod',
          label: '교체주기(년)',
          searchable: true,
          sortable: true,
          remoteProp: 'opi.change_period',
          formatter: this.getTableValueAfterCheckEmpty,
          width: 115,
        },
        {
          prop: 'useCount',
          label: '사용장비 대수',
          // scopedSlot: 'use-count',
          formatter: this.getTableValueAfterCheckEmpty,
          sortable: true,
          width: 130,
        },
        {
          prop: 'url',
          label: 'URL',
          searchable: true,
          sortable: true,
          formatter: this.getTableValueAfterCheckEmpty,
          remoteProp: 'opi.url',
        },
      ],
      total: null,
    };
  },
  mounted() {
    this.loadData();
  },
  methods: {
    isNil,
    loadData() {
      this.selectedRowArray = [];
      const tableParams = this.$refs.deviceModelTable.getParameter();
      const params = {
        ...tableParams,
      };
      NetdeviceLifeCycleSettingsAPI.getDeviceModelList(params).then((response) => {
        if (response.data.success) {
          this.tableData = response.data.data;
          this.total = response.data.total;
        }
      });
    },
    onChangeTable() {
      this.loadData();
    },
    setSearchToolVisible() {
      this.showSearchTool = !this.showSearchTool;
    },
    onAddDeviceLifeCycle() {
      this.$refs.deviceLifeCycleSlidingPopup.open();
    },
    onDblClickRow(row) {
      this.$refs.deviceLifeCycleSlidingPopup.open(row);
    },
    onDelDeviceLifeCycle() {
      this.$confirm('선택한 대상을 삭제하시겠습니까?', 'Warning', {
        confirmButtonText: '확인',
        cancelButtonText: '취소',
        type: 'warning',
      })
        .then(() => {
          NetdeviceLifeCycleSettingsAPI.deleteDeviceModelList(this.selectedRowArray).then((response) => {
            if (response.data.success) {
              this.loadData();
              this.$message(msgUtil.getCustomResultMsgData('삭제하였습니다.', true));
            } else {
              this.$message(msgUtil.getCustomResultMsgData('삭제하지 못하였습니다.', false));
            }
          });
        })
        .catch(() => {});
    },
    // 테이블 체크박스 셀렉션 change함수
    changeHandleSelection(selectVal) {
      this.selectedRowArray = selectVal;
    },
    getDateFormatter(row, column, value) {
      if (!isNil(value)) {
        return getDateToString(value, 'YYYY-MM-DD');
      }
      return EMPTY_TEXT;
    },
    onClickExcelExport() {
      NetdeviceLifeCycleSettingsAPI.exportDeviceModelList();
    },
    onClickExcelImport() {
      this.$refs.deviceModelExcelImportSliding.open();
    },
    getTableValueAfterCheckEmpty(row, column, value) {
      return getValueAfterCheckEmpty(value);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/settings/netdevice/DeviceModelSettings/DeviceLifeCycleManagement/index.vue